module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAT1JREFUeNp80r1KA0EYheFsskUKG0EUIYUiUbfz5w7SCUKIpY2i9lpo5V1oZ+MtCCI2XoCkERQk4F9EkGg0iopNYsb30zMybOHAk92d/c7MZmYi51wmaAUsYBYjiHCLQ+zi+q/SgjKHO/fbWqjiGA/qa2LJ1/tQBW18YhWFYMABBZ41wLIPDuIe7ygFARMF99N4xAsS69jUSGupkA/GwfO8arftRZW/WkSCRub/lse5LU3MzxBqCtnKjeErFciiiQpOUYrV2VVBL/oVdJLTtnR1/RnUPvVE+zeOlgpdMKt9XkdBm+jM+my2A/ShrEAnCNkM7SA4g1Ec2UoNa3OfMBWsYBY5Xe25iBt8YNIXLWqZG1rynmCAPMq4VM1GeHLMCl718gr72ENNfXaq1tNHzkuwhQu8SR07mAhrvwUYAAPcpzOOuewWAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/shipIcons/buttons/-.png
// module id = /rPq
// module chunks = 18